// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1g-1";
export var movingGradient = "_1g-4";
export var movingGradientBlock = "_1g-2";
export var skeleton = "_1g-0";
export var skeletonText = "_1g-3";